import {
  AutocompleteHit,
  BuiltinControlAutocompleteConfig,
  CplaceSingleReferenceControlChange,
  CplaceSingleReferenceControlParameters,
  ReferenceValue,
} from '../../api/model/models';
import { ControlChangeHandler } from '../../controls';
import { mockControlIdentity, mockControlStateSharedData } from './controls.shared';

export const mockCplaceSingleReferenceSearchBuiltinControlAutocompleteHits: AutocompleteHit[] = [
  {
    label: 'One reference',
    disambiguation: 'Landing Page',
    additionalLinkClasses: '',
    icon: 'fa fa-coffee',
    url: '#',
    uid: 'abc',
  },
  {
    label: 'Two reference',
    disambiguation: 'Landing Page',
    additionalLinkClasses: '',
    icon: 'fa fa-coffee',
    url: '#',
    uid: 'def',
  },
  {
    label: 'Three reference',
    disambiguation: 'Landing Page',
    additionalLinkClasses: '',
    icon: 'fa fa-coffee',
    url: '#',
    uid: 'ghi',
  },
  {
    label: 'Four reference',
    disambiguation: 'Landing Page',
    additionalLinkClasses: '',
    icon: 'fa fa-coffee',
    url: '#',
    uid: 'jkl',
  },
  {
    label: 'Five reference',
    disambiguation: 'Landing Page',
    additionalLinkClasses: '',
    icon: 'fa fa-coffee',
    url: '#',
    uid: 'mno',
  },
];

export const mockCplaceSingleReferenceControlReferenceItems: ReferenceValue[] =
  mockCplaceSingleReferenceSearchBuiltinControlAutocompleteHits.map((hit) => {
    return { label: hit.label, icon: hit.icon ?? '', uid: hit.uid, url: hit.url };
  });

export const mockAutocompleteConfig: BuiltinControlAutocompleteConfig = {
  type: 'builtin',
};

export const mockCplaceSingleReferenceControlControlParams: CplaceSingleReferenceControlParameters = {
  componentName: 'CplaceSingleReferenceControlComponent',
  value: mockCplaceSingleReferenceControlReferenceItems[0],
  autocompleteConfig: mockAutocompleteConfig,
};

export const mockCplaceSingleReferenceControlControlState = {
  ...mockControlStateSharedData,
  identity: mockControlIdentity,
  controlParameters: mockCplaceSingleReferenceControlControlParams,
};

export const mockCplaceSingleReferenceControlChangeHandler: ControlChangeHandler<
  CplaceSingleReferenceControlChange,
  CplaceSingleReferenceControlParameters,
  AutocompleteHit[]
> = (controlParameters, controlChange, mockData) => {
  return {
    ...controlParameters,
    value: mockData
      ?.filter((hit) => hit.uid === controlChange.value)
      .map((hit) => {
        return { uid: hit.uid, label: hit.label, url: hit.url, icon: hit.icon ?? '' };
      })
      .shift(),
  };
};
